import { request } from '../../utils/axios';

const publicPrefix = '/public';

// 查询首页分类模块
export const getIndexModule = async (params) => {
  return request.get(`${publicPrefix}/anonymous/getIndexModule`, { params });
};

// 查询公告
export const getNotice = async (params) => {
  return request.get(`${publicPrefix}/notice/list`, { params });
};

// 机构列表
export const getOrg = async (params) => {
  return request.get(`${publicPrefix}/anonymous/orgList`, { params });
};
// 机构详情
export const getOrgDetail = async (params) => {
  return request.get(`${publicPrefix}/anonymous/orgView`, { params });
};

// 专家列表
export const getExpert = async (params) => {
  return request.get(`${publicPrefix}/expert/list`, { params });
};
// 专家详情
export const getExpertDetail = async (params) => {
  return request.get(`${publicPrefix}/expert/queryById`, { params });
};

// 知识库列表
export const getKnowledge = async (params) => {
  return request.get(`${publicPrefix}/qualityKnowledge/list`, { params });
};
// 知识库详情
export const getKnowledgeDetail = async (params) => {
  return request.get(`${publicPrefix}/qualityKnowledge/queryById`, { params });
};

// 优秀案例列表
export const getAchievement = async (params) => {
  return request.get(`${publicPrefix}/qualityAchievement/list`, { params });
};
// 优秀案例详情
export const getAchievementDetail = async (params) => {
  return request.get(`${publicPrefix}/qualityAchievement/queryById`, { params });
};

// 提交投诉建议
export const submitFeedback = (data) =>
  request.post(`${publicPrefix}/anonymous/addComplaints`, data);

// 获取省/市/区 信息
export const getAreaInfo = async (params) => {
  return request.get(`${publicPrefix}/config/getAreaLevel`, { params });
};

// 查询公众端机构设备分页列表（公开接口）
export const getPublicDeviceList = async (params) => {
  return request.get(`${publicPrefix}/orgDevice/list`, { params });
};
